//引入js文件
import CryptoJS from 'crypto-js';

const keySecret = CryptoJS.enc.Utf8.parse('pigxpigxpigxpigx')

// 给单个值加密
export const encryptionStr = str => {
  if(!str) return ''
  let encrypted = CryptoJS.AES.encrypt(str, keySecret, {
    iv: keySecret,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  return encrypted.toString()
};
// 给单个值解密
export const decryptionStr = str => {
  console.log(str)
  if(!str) return ''
  let base64 = CryptoJS.enc.Base64.parse(str)
  let src = CryptoJS.enc.Base64.stringify(base64)
  const decipher = CryptoJS.AES.decrypt(src, keySecret, {
    iv: keySecret,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return decipher.toString(CryptoJS.enc.Utf8).toString().replace(/\u0000/g, "")
};
// 给对象中某几个字段的值加密
export const encryptionObj = (data = {}, encryption = []) => {
  let dateObj = { ...data }
  Object.keys(dateObj).forEach(key => {
    if(dateObj[key] && encryption.includes(key)) {
      dateObj[key] = encryptionStr(dateObj[key])
    }
  })
  return dateObj
};
// 给对象中某几个字段的值解密
export const decryptionObj = (data = {}, encryption = []) => {
  let dateObj = { ...data }
  Object.keys(dateObj).forEach(key => {
    if(dateObj[key] && encryption.includes(key)) {
      dateObj[key] = decryptionStr(dateObj[key])
    }
  })
  return dateObj
};